import { render, staticRenderFns } from "./DecodeMoneyPopup.vue?vue&type=template&id=0a46bb27&scoped=true"
import script from "./DecodeMoneyPopup.vue?vue&type=script&lang=ts"
export * from "./DecodeMoneyPopup.vue?vue&type=script&lang=ts"
import style0 from "./DecodeMoneyPopup.vue?vue&type=style&index=0&id=0a46bb27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a46bb27",
  null
  
)

export default component.exports